// extracted by mini-css-extract-plugin
export default {"HitsByCategories":"HitsByCategories--47ef861"};